import Router from '@route/router';
import DisabledScreenScal from '@utils/disabledScreenScal';
import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import eventBus from '@utils/eventBus';
import { Spin, message, notification } from 'antd';
import FloatHelper from './view/compoents/FloatHelper';
import PSAISpinDot from './PSAIComponents/PSAISpinDot';
import API from '@api/api'
import { AppContext } from './utils/AppContext';
import PSAIModal from './PSAIComponents/PSAIModal';
import AppealModal from './view/compoents/AppealModal';
import Vector from '@assets/images/Vector.svg'
import dayjs from 'dayjs';

function getBrowser(){
    var sys = {};
    var ua = navigator.userAgent.toLowerCase();
    console.log('userAgent', ua);
    var s;
    // eslint-disable-next-line no-unused-expressions
    (s = ua.match(/edge\/([\d.]+)/)) ? sys.edge = s[1] :
    (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? sys.ie = s[1] :
    (s = ua.match(/msie ([\d.]+)/)) ? sys.ie = s[1] :
    (s = ua.match(/firefox\/([\d.]+)/)) ? sys.firefox = s[1] :
    (s = ua.match(/chrome\/([\d.]+)/)) ? sys.chrome = s[1] :
    (s = ua.match(/opera.([\d.]+)/)) ? sys.opera = s[1] :
    (s = ua.match(/version\/([\d.]+).*safari/)) ? sys.safari = s[1] : 0;
 
    if (sys.edge) return { browser : "Edge", version : sys.edge };
    if (sys.ie) return { browser : "IE", version : sys.ie };
    if (sys.firefox) return { browser : "Firefox", version : sys.firefox };
    if (sys.chrome) return { browser : "Chrome", version : sys.chrome };
    if (sys.opera) return { browser : "Opera", version : sys.opera };
    if (sys.safari) return { browser : "Safari", version : sys.safari };
    
    return { browser : "", version : "0" };
}

function checkBrowserVersion () {
    const res = getBrowser()
    const browser = res.browser
    const version = res.version
    
    let mainVersion = 0
    if (version && version.split('.') && version.split('.').length > 0) {
        mainVersion = version.split('.')[0]
    }    

    console.log(browser, version)
    // 浏览器版本必须需要兼容:where() CSS选择器
    if (browser == 'Edge') return mainVersion >= 88
    if (browser == 'IE') return false
    if (browser == 'Firefox') return mainVersion >= 82
    if (browser == 'Chrome') return mainVersion >= 88
    if (browser == 'Opera') return mainVersion >= 74
    if (browser == 'Safari') return mainVersion >= 14

    return true
}

function App() {
    const location = useLocation()
    const navigate = useNavigate();
    const [messageApi, msgContextHolder] = message.useMessage()
    const [notificationApi, contextHolder] = notification.useNotification();
    const tokenExpiredRef = useRef(false)

    Spin.setDefaultIndicator(<PSAISpinDot />)

    const handleTokenValid = () => {
        tokenExpiredRef.current = false
    }

    const handleTokenExpired = (msg) => {
        if (tokenExpiredRef.current) return
        tokenExpiredRef.current = true
        message.warning('凭证已过期，请重新登录')
        navigate(`/?redirect=${encodeURIComponent(msg.pathname)}`)
    }

    const handleNavigateTo = (url, options) => {
        navigate(url, options)
    }

    const handleNotification = (title, message, type='info', key) => {
        notificationApi[type]({
            key,
            message: title,
            description: message,
        })
    }

    const handleRecharge = () => {
        navigate("/#membership")
    }

    const handleRewardMessage = (content, amount) => {
        messageApi.open({
            content: <p style={{display: 'flex', alignItems: 'center'}}>
                <img  style={{marginRight: '10px', width: '18px', height: '20px'}} src={Vector} alt="" />
                温馨提示：{content}已到账。
                <span style={{color: '#FF6332', marginLeft: '20px', display: 'flex', alignItems: 'baseline'}}>+ <span style={{fontSize: '24px'}}>{amount}</span>
                <img style={{marginLeft: '10px', width: '14px', height: '14px'}}  src={require('@assets/images/arcbean2.png')} alt="" />
                </span>
                </p>,
            duration: 10
        });
    }

    const {setGlobalBalance, setGlobalUser, setGlobalOrderList} = useContext(AppContext)
    const [acquirePower, setAcquirePower] = useState(false)
    useEffect(() => { // 提醒登录送点
        if (acquirePower) eventBus.emit('rewardMessage', '今日登录赠送豆数', 100)
    }, [acquirePower])
    const handleUpdatePower = () => {
        return API.getPowerBalance().then(res => {
            if (res.code != 0) return
            setGlobalBalance(res.data.balance)
            setAcquirePower(res.data.acquirePower)
        })
    }
    const updateOrderList = () => {
        API.getOrderList({}).then((res) => {
            if(res.code == 0) setGlobalOrderList([...res.data])
        })
    }
    const updateUserInfo = () => {  
        API.userInfo({}).then((res) => {
            if(res.code == 0) setGlobalUser({
                ...res.data,
                // cmCount: 2, // mock数据
                // cmReadFlag: 0, // mock数据
                // appealBeforeTime: '2024-04-28' // mock数据
            })
        })
    }

    /****** 违规警告 ******/
    const [token, setToken] = useState()
    const tokenRef = useRef()
    const appealTitleRef = useRef()
    const [appealOpen, setAppealOpen] = useState(false)
    const modalInstance = useRef(null)
    const appealClick = (title) => {
        console.log('appealClick', title)
        // modalInstance.current.destroy()
        appealTitleRef.current = title
        setAppealOpen(true) 
    }
    const hadnleViolationWarn = (cmCount, appealBeforeTime) => {
        if (modalInstance.current) modalInstance.current.destroy()
        const today = dayjs()
        modalInstance.current = PSAIModal.confirm({
            content: (
                <div className='home_appeal'>
                    <p>经审核，您上传了涉嫌违规的内容，警告{cmCount}次。违规累计超过三次，将对账号进行封号处理。</p>
                    {
                        dayjs(appealBeforeTime).isBefore(today, 'day') ? "" :
                        <p>请在{appealBeforeTime}前进行申诉，超过时间无法申诉。<span onClick={() => appealClick('账号警告申诉')}>去申诉</span></p>
                    }                    
                </div>
            ),
            okText: '确认',
            cancelText: '取消',
            onOk() {API.setCmRead()},
            onCancel() {API.setCmRead()},
        })
    }

    /******** 封号提醒 ********/
    const handleSuspenNotice = (num, invalidDays, appealBeforeTime, token) => {
        console.log('handleSuspenNotice===')
        if (modalInstance.current) modalInstance.current.destroy()
        setToken(token)
        tokenRef.current = token
        const today = dayjs()
        modalInstance.current = PSAIModal.confirm({
            content: (
                <div className='home_appeal'>
                    <p>经审核，您的账号已累计违规{num}次，现对您的账号进行封号{invalidDays}天的处理。</p>
                    {
                        dayjs(appealBeforeTime).isBefore(today, 'day') ? "" :
                        <p>请在{appealBeforeTime}前进行申诉，超过时间无法申诉。<span onClick={() => appealClick('账号解封申诉')}>去申诉</span></p>
                    }
                </div>
            ),
            okText: '确认',
            cancelText: '取消',
            onOk() {onAfterSuspendNotice(1, token)},
            onCancel() {onAfterSuspendNotice(1, token)},
        })
    }
    const onAfterSuspendNotice = (type, token) => {
        if (token) return
        API.setCmRead()
        if (type == 1) { // 封号后需要主动退出登录
            API.logout({}).finally(() => {
                navigate("/")
                localStorage.removeItem('token')
                sessionStorage.removeItem('taskCache_model')
                sessionStorage.removeItem('taskCache_dressform')
                sessionStorage.removeItem('taskCache_clothes')
                sessionStorage.removeItem('taskCache_commodity')
                localStorage.removeItem('channel')
            })
        }
    }
    
    useEffect(() => {
        eventBus.on('tokenValid', handleTokenValid);
        eventBus.on('tokenExpired', handleTokenExpired);
        eventBus.on('navigateTo', handleNavigateTo);
        eventBus.on('notification', handleNotification)
        eventBus.on('recharge', handleRecharge) // 充值
        eventBus.on('rewardMessage', handleRewardMessage) // 赠送点弹窗
        eventBus.on('updatePower', handleUpdatePower) // 更新虹豆数
        eventBus.on('updateUserInfo', updateUserInfo) // 更新用户信息
        eventBus.on('violationWarn', hadnleViolationWarn) // 违规警告
        eventBus.on('suspenNotice', handleSuspenNotice) // 封号提醒
        eventBus.on('updateOrderList', updateOrderList) // 更新订单信息

        return () => {
            eventBus.off('tokenValid', handleTokenValid);
            eventBus.off('tokenExpired', handleTokenExpired);
            eventBus.off('navigateTo', handleNavigateTo);
            eventBus.off('notification', handleNotification)
            eventBus.off('recharge', handleRecharge)
            eventBus.off('rewardMessage', handleRewardMessage)
            eventBus.off('updatePower', handleUpdatePower)
            eventBus.off('updateUserInfo', updateUserInfo)
            eventBus.off('violationWarn', hadnleViolationWarn)
            eventBus.off('violationWarn', handleSuspenNotice)
            eventBus.off('updateOrderList', updateOrderList)
        }
    }, [])

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const inviteCode = searchParams.get('invite_code')
        if (inviteCode) sessionStorage.setItem('inviteCode', inviteCode)
    }, [])

    const [browserIsAvailable, setBrowserIsAvailable] = useState(true)
    useEffect(() => {
        console.log('===checkBrowserVersion===')
        const result = checkBrowserVersion()
        setBrowserIsAvailable(result)
    }, [])

    return (
        <div className="App" id="topView">
            {contextHolder}
            {msgContextHolder}
            {
                browserIsAvailable ? 
                    <>
                    <Router />
                    <FloatHelper />
                    </>:
                    <div className="browser_not_available">
                        <i></i>
                        <span>您使用的浏览器不能正常浏览网站，请使用最新版本的浏览器以获得更好的网站浏览体验。</span>
                    </div>
            }
            <PSAIModal
                title="账号申诉"
                open={appealOpen}
                maskClosable={false}
                footer={null}
                maxWidth={664}
                onCancel={() => setAppealOpen(false)}
                getContainer={"body"}
            >
                <AppealModal token={token} onCancel={() => setAppealOpen(false)} />
            </PSAIModal>
        </div>
    );
}

// DisabledScreenScal.disabledZoom()


export default App;
